import { adminHttpClient } from '../../../commons/adminHttpClient'

export type GetBenefitUsageDetailsRequestsResponse = {
  totalUsage: GetBenefitUsageDetailsTotalUsage
  categoryUsages: GetBenefitUsageDetailsCategoryUsage[]
}

export type GetBenefitUsageDetailsTotalUsage = {
  id: number
  categoryName: string
  totalAllowance: number
  allowanceUsed: number
  percentageIncrease: number
  percentageUsed: number
  color: string
}

export type GetBenefitUsageDetailsCategoryUsage = {
  id: number
  categoryName: string
  totalAllowance: number
  allowanceUsed: number
  offerSameAllowance: boolean
  percentageIncrease: number
  percentageUsed: number
  color: string
}

export const getBenefitUsageDetails = (planPeriodId: string): Promise<GetBenefitUsageDetailsRequestsResponse> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/Reimbursements/GetBenefitUsageDetails/${planPeriodId}`)
}
